import { API } from "../../api";


export const dashboardExtendedApi = API.injectEndpoints({
    endpoints: (builder) => ({
        dashboard: builder.query({
            query: ({ weekly = false, year = new Date().getFullYear() }) => {
                return {
                    // next7days: staff dashboard day picker is Today → +6 days; "today" hid Tomorrow+
                    url: `/cooperatives/dashboard?guard=staff&filter=${weekly ? "weekly" : "monthly"}&meetingFilter=next7days&year=${year}`,
                    method: "GET",
                };
            },
            transformResponse: (responseData) => {
                // Handle error responses gracefully
                if (!responseData?.data) return null;
                return responseData;
            },
            providesTags: ["StaffDashboard"],
            // Prefer fresh branch/financial totals when remounting the dashboard
            keepUnusedDataFor: 30,
        })
    })
})


export const {
    useDashboardQuery
} = dashboardExtendedApi;
